import { createAction } from '@reduxjs/toolkit';

export const updateTeamsInfoMapping = createAction('updateTeamsInfoMapping', (params) => ({
  payload: params,
}));
